import { render, staticRenderFns } from "./QuickBindDialog.vue?vue&type=template&id=0fa38d6d&scoped=true&"
import script from "./QuickBindDialog.vue?vue&type=script&lang=ts&"
export * from "./QuickBindDialog.vue?vue&type=script&lang=ts&"
import style0 from "./QuickBindDialog.vue?vue&type=style&index=0&id=0fa38d6d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa38d6d",
  null
  
)

export default component.exports